module.exports = __webpack_public_path__ + "static/img/Darcy_Moore_desktop.40111c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Darcy_Moore_desktop.jpg
// module id = 2Moy
// module chunks = 0